'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("AbonnementSyntheseMailPopinController", function ($scope, $q, $http, $translate, $session, $notifications, $authz) {
  $scope.compte = $session.getCompte().nomClient;
  $scope.frequences = [{
    id: 'MENSUELLE',
    label: 'En début de mois'
  }, {
    id: 'TRIMESTRIELLE',
    label: 'En début de trimestre'
  }, {
    id: 'SEMESTRIELLE',
    label: 'En début de semestre'
  }
  //        {id: 'ANNUELLE', label: 'En début d\'année'},
  ];
  if ($authz.hasRole('IT_ADMINISTRATION')) {
    $scope.frequences.push({
      id: 'QUOTIDIENNE',
      label: 'Tous les jours (uniquement pour les admin it)'
    });
  }
  $scope.momentFrequences = [{
    id: 'DEBUT_PERIODE',
    label: 'début de période'
  }, {
    id: 'FIN_PERIODE',
    label: 'fin de période'
  }];
  $scope.abonnement = {
    frequence: 'MENSUELLE',
    //momentFrequence: 'DEBUT_PERIODE',
    premiereSyntheseImmediate: true,
    abonneIds: []
  };
  $http.get('/rest/abonnementSyntheseDette/infos-pour-inscription').then(function (response) {
    $scope.info = response.data;
    $scope.abonnables = response.data.utilisateursAbonnables;
    $scope.utilisateursDejaAbonnes = response.data.utilisateursDejaAbonnes;
    $scope.abonnements = response.data.abonnements;
    $scope.abonnables = $scope.abonnablesList = _.map($scope.abonnables, function (user) {
      return {
        id: user.id,
        label: user.prenom + " " + user.nom
      };
    });
    var moi = _.find($scope.abonnables, {
      id: $session.getUser().id
    });
    if (moi) {
      $scope.abonnement.abonneIds.push(moi.id);
    }
  });
  $scope.formConfig = {
    url: function url() {
      return "/rest/abonnementSyntheseDette/abonnement";
    },
    data: function data() {
      return $scope.abonnement;
    },
    fieldPrefix: "abonnement.",
    onSuccess: function onSuccess(abonnement) {
      $notifications.info('Abonnement effectué.');
      $scope.$close(abonnement);
    },
    customValidation: function customValidation() {
      var errors = [];
      return errors;
    }
  };
  $scope.params = {
    newAbonneId: null
  };
  $scope.abonneList = function () {
    return _.filter($scope.abonnables, function (d) {
      return _.indexOf($scope.abonnement.abonneIds, d.id) === -1;
    });
  };
  $scope.removeAbonne = function (id) {
    var index = _.indexOf($scope.abonnement.abonneIds, id);
    $scope.abonnement.abonneIds.splice(index, 1);
  };
  $scope.addAbonne = function () {
    var abonneId = $scope.params.newAbonneId;

    // si non deja présent dans la liste on l'ajoute
    if (abonneId != null && _.indexOf($scope.abonnement.abonnesId, abonneId) === -1) {
      if ($scope.abonnement.abonneIds == null) {
        $scope.abonnement.abonneIds = [];
      }
      $scope.abonnement.abonneIds.push(abonneId);
    }
    $scope.params.newAbonneId = null;
  };
  $scope.renderUser = function (userId) {
    if ($scope.abonnables) {
      var ts = _.find($scope.abonnables, {
        id: userId
      });
      if (ts) {
        return ts.label;
      }
      return "[" + userId + "]";
    }
  };
  $scope.tableConfig = {
    id: "abonnementSynthese",
    source: "abonnements",
    allowSelection: true,
    selectionScope: $scope,
    selectionAttribute: "selected",
    initialSort: [0, "asc"],
    columns: [{
      attribute: 'utilisateur',
      title: "",
      cellClass: 'align-c',
      width: "25px"
    }]
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/abonnementSyntheseMail/abonnementSyntheseMailPopinController.js
// module id = 2677
// module chunks = 13